// books/mgm.js — BetMGM per-book SlipSync config.
// Single job: supply MGM-specific WebView/sync parameters to the shared client framework.
// Reads (does not edit) the frozen constants + injected-script source.
import { VALID_STATES, getBetmgmWebViewUrl } from '../constants';
import { getBetmgmFetchScript } from '../betmgm-client';

export const mgmConfig = {
  key: 'mgm',
  displayName: 'BetMGM',
  stage: 'import',
  needsRegionSelection: true,
  validRegions: VALID_STATES,
  getWebViewUrl: (region) => getBetmgmWebViewUrl(region),
  getFetchScript: (region, nonce) => getBetmgmFetchScript(region, nonce),
  scriptHosts: ['betmgm.com'], // #1409: the fetch script runs only on these hosts (and their subdomains)
  webViewTitle: 'Sign in to BetMGM to sync',
  // 2026-10-18: the bet-history route (a path segment below). An allowlist, not "any non-sign-in route": an unknown
  // 2FA/verify path must never close the window mid-sign-in.
  betHistorySegments: ['my-bets', 'mybets'],
  // Closes at once on the bet-history route (cookie-bridge.js): with the two-call URLs a signed-out request gets 401
  // (verified 2026-10-18), so a redirect to /Account/AccessDenied means BetMGM refused the call. No other answer
  // closes the window: BetMGM answers 5xx, error bodies and redirects before sign-in too (GitHub Codex P1, eda514bb).
  definitiveNoBetsReasons: ['access_denied'],
  errorMessages: null, // MGM uses the shared ERROR_MESSAGES base; DK supplies overrides later
};
